import React, { Suspense } from 'react';

import {
  InteractionAccordionPanelProps,
  InteractionModalComponentProps,
} from '$/components/Interactions/types';

import { PurchasePixel } from '$/components/ui/Input/Editors/EmbedCodeBox';

import { useMe } from '$/hooks/useMe';
import { createWebinarSetPurchasePixelUrl } from '$/utils/pixel';
import Form from '$/components/ui/Form';
import Settings from '$/components/ui/Settings';

const OfferSettings = React.lazy(() => import('./OfferSettings'));
const PurchaseTrackingPopup = React.lazy(() => import('./PurchaseTrackingPopup'));

export const useOfferSettings: (
  props: InteractionModalComponentProps
) => InteractionAccordionPanelProps[] = (props) => {
  const { state } = props;
  const me = useMe();
  const pixelUrl = createWebinarSetPurchasePixelUrl(me.team, state.set.id);
  return [
    {
      key: 'Settings',
      active: true,
      title: { content: <Form.AccordionTitle title={'Settings'} /> },
      content: {
        content: (
          <Suspense>
            <OfferSettings {...props} />
          </Suspense>
        ),
      },
    },
    {
      key: 'SalesTracking',
      title: {
        content: (
          <Form.AccordionTitle
            title={
              <div className='inline-flex'>
                Conversion tracking{' '}
                <Suspense>
                  <PurchaseTrackingPopup />
                </Suspense>
              </div>
            }
          />
        ),
      },
      content: {
        content: (
          <>
            <div className='flex flex-col flex-grow justify-center items-center'>
              <Settings.Description>
                Put this code in your checkout page. Even if you have more than one Offer card in
                your webinar you only need to copy and paste this code once. For more help see{' '}
                <a
                  href='https://ewebinar.com/help/how-do-i-track-product-sales-from-offers-made-in-ewebinar'
                  target='_blank'
                  rel='noopener'
                >
                  this help article
                </a>
                .
              </Settings.Description>
              <PurchasePixel purchasePixelUrl={pixelUrl} />
            </div>
          </>
        ),
      },
    },
    // Temporarily hide this accordion until New Attendee UI is done
    // {
    //   key: 'OverlayButton',
    //   active: true,
    //   title: {
    //     content: <Form.AccordionTitle title={'Video overlay button'} />,
    //   },
    //   content: {
    //     content: <ButtonOverlayComponent state={state} />,
    //   },
    // },
  ];
};
